import CContainer from '@/components/CContainer'

const defaultFavicon = `${process.env.BASE_URL}favicon.ico`

export default function page (title = '') {
  return {
    components: {
      CContainer
    },

    meta () {
      const favicon = this.getters['org/favicon'] || defaultFavicon
      return {
        link: [
          { rel: 'icon', href: favicon }
        ],
        title: this.pageTitle
      }
    },
    data: () => ({
      pageTitle: title
    })
  }
}
